(function () {
  'use strict';

  var DAYS = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];

  function londonDay() {
    try {
      return new Intl.DateTimeFormat('en-GB', {
        weekday: 'long',
        timeZone: 'Europe/London'
      }).format(new Date()).toLowerCase();
    } catch (error) {
      return DAYS[new Date().getDay()];
    }
  }

  function initialise(root) {
    if (root.dataset.scheduleInitialised === 'true') return;
    root.dataset.scheduleInitialised = 'true';
    loadLiveSchedule(root).then(function () {
      enhanceTabs(root);
    }).catch(function () {
      var status = root.querySelector('[data-schedule-status]');
      if (status) status.textContent = 'The live timetable is temporarily unavailable. Please try again shortly.';
      var tabs = root.querySelector('.hbc-schedule__tabs');
      var panels = root.querySelector('.hbc-schedule__panels');
      if (tabs) tabs.replaceChildren();
      if (panels) panels.replaceChildren();
    });
  }

  function enhanceTabs(root) {
    var tabs = Array.from(root.querySelectorAll('[data-schedule-tab]'));
    var panels = Array.from(root.querySelectorAll('[data-schedule-panel]'));
    if (!tabs.length || !panels.length) return;
    root.classList.add('is-enhanced');

    function activate(day, focusTab) {
      var selectedTab = null;

      tabs.forEach(function (tab) {
        var selected = tab.dataset.scheduleTab === day;
        tab.setAttribute('aria-selected', String(selected));
        tab.tabIndex = selected ? 0 : -1;
        if (selected) selectedTab = tab;
      });

      panels.forEach(function (panel) {
        panel.hidden = panel.dataset.schedulePanel !== day;
      });

      if (focusTab && selectedTab) selectedTab.focus();
    }

    var available = tabs.map(function (tab) { return tab.dataset.scheduleTab; });
    var requested = root.dataset.defaultDay;

    if (requested === 'today') {
      var todayIndex = DAYS.indexOf(londonDay());
      requested = DAYS.slice(todayIndex).concat(DAYS.slice(0, todayIndex)).find(function (day) {
        return available.indexOf(day) !== -1;
      });
    }

    if (available.indexOf(requested) === -1) requested = available[0];
    activate(requested, false);

    tabs.forEach(function (tab, index) {
      tab.addEventListener('click', function () {
        activate(tab.dataset.scheduleTab, false);
      });

      tab.addEventListener('keydown', function (event) {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        var direction = event.key === 'ArrowRight' ? 1 : -1;
        var nextIndex = (index + direction + tabs.length) % tabs.length;
        activate(tabs[nextIndex].dataset.scheduleTab, true);
      });
    });
  }

  function loadLiveSchedule(root) {
    var apiUrl = root.dataset.timetableApiUrl;
    if (!apiUrl) return Promise.reject(new Error('missing-timetable-url'));
    var tabsHost = root.querySelector('.hbc-schedule__tabs');
    var panelsHost = root.querySelector('.hbc-schedule__panels');
    var status = root.querySelector('[data-schedule-status]');
    var controller = typeof AbortController === 'function' ? new AbortController() : null;
    var timer = controller ? window.setTimeout(function () { controller.abort(); }, 8000) : null;
    return fetch(apiUrl, {
      method: 'GET', credentials: 'omit', signal: controller ? controller.signal : undefined
    }).then(function (response) {
      if (!response.ok) throw new Error('timetable-request-failed');
      return response.json();
    }).then(function (data) {
      if (!data || data.ok !== true || !Array.isArray(data.classes) || !data.classes.length) {
        throw new Error('invalid-timetable');
      }
      renderLiveSchedule(root, tabsHost, panelsHost, data.classes);
      if (status) status.remove();
    }).finally(function () {
      if (timer) window.clearTimeout(timer);
    });
  }

  function renderLiveSchedule(root, tabsHost, panelsHost, classes) {
    if (!tabsHost || !panelsHost) throw new Error('missing-timetable-host');
    var byDay = new Map();
    classes.forEach(function (item) {
      var day = String(item.day || '').toLowerCase();
      var time = String(item.time || '').slice(0, 5);
      var name = String(item.className || '').trim();
      if (DAYS.indexOf(day) === -1 || !/^\d{2}:\d{2}$/.test(time) || !name) return;
      if (!byDay.has(day)) byDay.set(day, []);
      byDay.get(day).push({ time: time, name: name, level: String(item.level || '') });
    });
    tabsHost.replaceChildren();
    panelsHost.replaceChildren();
    DAYS.slice(1).concat(DAYS[0]).forEach(function (day) {
      var sessions = byDay.get(day) || [];
      if (!sessions.length) return;
      sessions.sort(function (a, b) { return a.time.localeCompare(b.time); });
      var panelId = 'schedule-live-' + day + '-' + Math.random().toString(36).slice(2, 8);
      var tab = document.createElement('button');
      tab.type = 'button'; tab.className = 'hbc-schedule__tab'; tab.setAttribute('role', 'tab');
      tab.setAttribute('aria-selected', 'false'); tab.setAttribute('aria-controls', panelId);
      tab.dataset.scheduleTab = day;
      var tabName = document.createElement('span'); tabName.textContent = day.slice(0, 3);
      var count = document.createElement('small'); count.textContent = String(sessions.length);
      tab.append(tabName, count); tabsHost.appendChild(tab);

      var panel = document.createElement('div'); panel.className = 'hbc-schedule__panel';
      panel.id = panelId; panel.setAttribute('role', 'tabpanel'); panel.dataset.schedulePanel = day;
      var heading = document.createElement('div'); heading.className = 'hbc-schedule__day-heading';
      var title = document.createElement('h3'); title.textContent = day.charAt(0).toUpperCase() + day.slice(1);
      var total = document.createElement('span'); total.textContent = sessions.length + (sessions.length === 1 ? ' class' : ' classes');
      heading.append(title, total); panel.appendChild(heading);
      var list = document.createElement('ol'); list.className = 'hbc-schedule__list';
      sessions.forEach(function (session) {
        var row = document.createElement('li'); row.className = 'hbc-schedule__session';
        var time = document.createElement('time'); time.className = 'hbc-schedule__time'; time.textContent = session.time;
        var details = document.createElement('div'); details.className = 'hbc-schedule__class';
        var name = document.createElement('strong'); name.textContent = session.name; details.appendChild(name);
        var level = document.createElement('span'); level.className = 'hbc-schedule__level hbc-schedule__level--all';
        level.textContent = session.level ? session.level.charAt(0).toUpperCase() : 'All';
        row.append(time, details, level); list.appendChild(row);
      });
      panel.appendChild(list); panelsHost.appendChild(panel);
    });
    if (!tabsHost.children.length) throw new Error('empty-timetable');
  }

  function initialiseAll(scope) {
    var roots = [];
    if (scope.matches && scope.matches('[data-hbc-schedule]')) roots.push(scope);
    roots = roots.concat(Array.from(scope.querySelectorAll('[data-hbc-schedule]')));
    roots.forEach(initialise);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initialiseAll(document); });
  } else {
    initialiseAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initialiseAll(event.target);
  });
})();
